"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var NormaliseDatesMethod;

(function (NormaliseDatesMethod) {
  NormaliseDatesMethod["arithmetic"] = "arithmetic";
  NormaliseDatesMethod["geometric"] = "geometric";
})(NormaliseDatesMethod = exports.NormaliseDatesMethod || (exports.NormaliseDatesMethod = {}));